import { render, staticRenderFns } from "./CardTimeline.vue?vue&type=template&id=fa2d67bc&scoped=true"
import script from "./CardTimeline.vue?vue&type=script&lang=js"
export * from "./CardTimeline.vue?vue&type=script&lang=js"
import style0 from "./CardTimeline.vue?vue&type=style&index=0&id=fa2d67bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2d67bc",
  null
  
)

export default component.exports